<section class="page-intro legal-page">
  <p class="kicker">CapiTrade</p>
  <h1>{{ page().title }}</h1>
  @for (paragraph of page().body; track paragraph) {
    <p class="lede">{{ paragraph }}</p>
  }
  @if (page().slug === 'privacy') {
    <p class="fine"><a href="/privacy-policy.pdf" target="_blank" rel="noopener">{{ lang.t('lgPdf') }}</a></p>
  }
  <p class="fine"><a routerLink="/">{{ lang.t('lgHome') }}</a></p>
</section>
